// Defines an error that occurs for a non-2xx response.
// NOTE: Currently it is the responsibility of the thrower to ensure it is a non-2xx status code.

export default class ResponseError extends Error {
  constructor(
    public message: string,
    public response: Response,
    public retryable = true,
  ) {
    super(message);
  }
}

export function isResponseError(value: unknown): value is ResponseError {
  const error = value as ResponseError;
  return (
    error &&
    error.response !== undefined &&
    error.retryable !== undefined &&
    !error.response.ok
  );
}
